// src/utils/chatManager.js
import request from '@/common/js/request.js';
import TencentCloudChat from '@tencentcloud/chat';
import TIMUploadPlugin from 'tim-upload-plugin';
import { v4 as uuidv4 } from 'uuid';

let appKey = null;
let chatClient = null;
let chatClientWaitingQueue = [];
let isInitialized = false; // 添加初始化状态标记

// 存储当前登录状态和用户信息
let isLoggedIn = false;
let isChatSDKReady = false;
let kickouted = false; //由于被踢下线导致的重连 → 获取新的访客用户
let allFriends = [];
let allBlacklist = [];
let allFriendApplicationList = [];
// 我方业务ID
let lastRequset = null;
let currentUserID = null;
let currentToken = null;
let loginPromise = null;

let registerEventsQueue = [];
// 注册事件
const registerEvent = (event,handler) => {
	// 添加事件处理器
	return registerEvents([{event, handler}]);
};
// 添加事件处理器
const registerEvents = (events) => {
	console.log(`注册事件处理器: `,events);
	if (!chatClient) return;
	events.forEach(e=>{
		if(chatClient){
			chatClient.on(e.event, e.handler);
		}else{
			registerEventsQueue.push(()=>{
				chatClient.on(e.event, e.handler);
			})
		}
	})
	return {
		unregister:()=>unregisterEvents(events),
	}
};
// 注销事件
const unregisterEvents = (events) => {
	console.log(`注销事件处理器: `,events.map(e=>e.event).join('、'));
	if (!chatClient) return;
	events.forEach(e=>{
		chatClient.off(e.event,e.handler);
	})
};

// 获取 appKey 的函数
const getAppKey = () => {
	let StartUp = localStorage.getItem('qx2StartUp');
	if (StartUp) {
		StartUp = JSON.parse(StartUp);
		if (StartUp?.configData?.RTCAppKey) {
			return StartUp.configData.RTCAppKey;
		}
	}
	return null;
};
// 初始化 chatClient
const initChatClient = () => {
	if (isInitialized) return; // 防止重复初始化
	appKey = getAppKey();
	console.log(appKey,'appKey----------------');
	if (appKey && !chatClient) {
		try {
			// 创建 SDK 实例
			// `TencentCloudChat.create()` 方法对于同一个 `SDKAppID` 只会返回同一份实例
			chatClient = TencentCloudChat.create({SDKAppID: appKey});
			chatClientWaitingQueue.forEach(({resolve}) => resolve(chatClient));
			// 设置 SDK 日志级别
			// 0: 普通级别，日志量较多，接入时建议使用
			// 1: release 级别，SDK 输出关键信息，生产环境时建议使用
			chatClient.setLogLevel(0);
			// chatClient.setLogLevel(1);

			// 注册腾讯云即时通信 Chat 上传插件
			chatClient.registerPlugin({'tim-upload-plugin': TIMUploadPlugin});

			registerEvents([
				// SDK 进入 ready 状态时触发，接入侧监听此事件，然后可调用 SDK 发送消息等 API，使用 SDK 的各项功能。
				{
					event:TencentCloudChat.EVENT.SDK_READY,
					handler:(e)=>{
						console.log('SDK就绪');
						isChatSDKReady = true;
					},
				},
				// SDK 进入 not ready 状态时触发，此时接入侧将无法使用 SDK 发送消息等功能。如果想恢复使用，接入侧需调用 login 接口，驱动 SDK 进入 ready 状态。
				{
					event:TencentCloudChat.EVENT.SDK_NOT_READY,//SDK未就绪,
					handler:(e)=>{
						console.log('SDK未就绪,');
						isChatSDKReady = false;
						login(currentUserID, request);
					},
				},
				// 用户被踢下线时触发
				{
					event:TencentCloudChat.EVENT.KICKED_OUT,
					handler:(e)=>{
						isLoggedIn = false;
						kickouted = true;
						login(currentUserID, request);
					},
				},
				// 获取 SDK 缓存的好友列表。当好友列表有更新时，SDK 会派发事件
				{
					event:TencentCloudChat.EVENT.FRIEND_LIST_UPDATED,
					handler:(e)=>{
						console.log('获取好友列表', e);
						allFriends.length = 0;
						if (e.data.length>0) {
							e.data.forEach( ac=>{
								if (ac.profile) {
									Object.assign(ac, ac.profile);
								}
							});
							allFriends.push(...e.data);
						}
					},
				},
				// 当黑名单有更新时，SDK会派发
				{
					event:TencentCloudChat.EVENT.BLACKLIST_UPDATED,
					handler: async(e)=>{
						console.log('黑订单列表', e);
						allBlacklist.length = 0;
						if (e.data.length>0) {
							let _userInfos = await getUserInfos(e.data)
							allBlacklist.push(..._userInfos);
						}
					},
				},
				// 获取好友申请列表
				{
					event:TencentCloudChat.EVENT.FRIEND_APPLICATION_LIST_UPDATED,
					handler: (e)=>{
						console.log('好友申请列表', e);
						allFriendApplicationList.length = 0;
						if (e.data.friendApplicationList.length>0) {
							//将好友申请存入localStorage
							const applicationSentToMe = e.data.friendApplicationList.filter((friendApplication) => friendApplication.type === TencentCloudChat.TYPES.SNS_APPLICATION_SENT_TO_ME);
							const applicationSentByMe = e.data.friendApplicationList.filter((friendApplication) => friendApplication.type === TencentCloudChat.TYPES.SNS_APPLICATION_SENT_BY_ME);
							localStorage.setItem('friendApplicationList1', JSON.stringify(applicationSentByMe));
							allFriendApplicationList.push(...applicationSentToMe);
						}
					},
				},
			])

			console.log('ChatClient initialized successfully:', chatClient, TencentCloudChat);
			isInitialized = true;
		} catch (error) {
			console.log('Failed to initialize ChatClient:', error);
		}
	}
};

// 轮询获取 appKey 并初始化
const waitForAppKeyAndInit = () => {
	initChatClient();
	if (!isInitialized) {
		setTimeout(() => {
			waitForAppKeyAndInit();
		}, 2000);
	}
};

// 启动初始化过程
waitForAppKeyAndInit();

let ChatClient = ()=>{
	return chatClient;
}
let AllFriends = ()=>{
	return allFriends;
}
let AllBlacklist = ()=>{
	return allBlacklist;
}
let AllFriendApplicationList = ()=>{
	return allFriendApplicationList;
}
// 获取token并登录
const login = async (userID) => {
	if (loginPromise) {
		return loginPromise;
	}
	loginPromise = (async () => {
	try {
		if (!chatClient) {
			console.log('ChatClient not initialized');
			return Promise.resolve({succ: false, isChatSDKReady, msg: "ChatClient not initialized"});
		}
		if (isLoggedIn && currentUserID === userID && !kickouted) {
			console.log('Already logged in as', userID, 'isChatSDKReady:',isChatSDKReady);
			return Promise.resolve({succ: true, isChatSDKReady, msg: "Already logged"});
		}else{
			if (isLoggedIn) {
				await logout();
			}
		}
		let postdata = {
			url: '/ChatRoomToken',
			method: 'post',
		};
		if (kickouted) Object.assign(postdata.data, {kickouted});

		var resToken = await request(postdata);
		var data = resToken.data;

		if(data.code != 200) throw("无法获取到登录token!");
		if(!data.data || !data.data.userID || !data.data.token) throw("从业务服务器获取到了意料之外的数据！");
		
		const option = {
			userID: data.data.userID,
			userSig: data.data.token,
		};
		console.log("即将登录腾讯IM", option);
		let loginRes = {};
		await chatClient.login(option).then( async (res)=>{
			loginRes = res.data;
			console.log("登录腾讯IM回调", res);
			if (res.data.authKey && res.data.actionStatus=="OK") {
				currentUserID = option.userID;
				currentToken = option.userSig;
				isLoggedIn = true; // 标记已登录，连接成功才是登录成功标志
				kickouted = false;
			}
		}).catch( err=>{
			loginRes = err;
			console.log("登录腾讯IM回调", err);
			isLoggedIn = false;
			kickouted = false;
		})
		await (async function awaitReady(){
			return new Promise( async(resolve)=>{
				if(isChatSDKReady) {
					resolve();
				} else {
					setTimeout(()=>{
						return awaitReady().then(()=>{
							resolve();
						})
					},50)
				}
			})
		})()
		await (async function awaituserInfo(){
			return new Promise( async(resolve)=>{
				let _userInfo = localStorage.getItem('qx2userInfo');
				if(_userInfo){
					let userInfo = JSON.parse(_userInfo);
					await chatClient.getMyProfile().then( async(mres)=>{
						console.log(mres);
						if (!mres.data.nick) {
							let updateMyProfileOption = { nick: userInfo.nickName, allowType:TencentCloudChat.TYPES.ALLOW_TYPE_NEED_CONFIRM };
							if (userInfo.photo) {
								Object.assign(updateMyProfileOption, {avatar: userInfo.photo,})
							}
							await chatClient.updateMyProfile(updateMyProfileOption).then( ures=>{
								console.log(ures);
							}).catch(uerr=>{
								console.log(uerr);
							}).finally(()=>{
								resolve();
							})
						}else {
							resolve();
						}
					}).catch(merr=>{
						console.log(merr);
					})
				} else {
					resolve();
				}
			})
		})()
		return Object.assign(loginRes, {succ: isLoggedIn, isChatSDKReady });
	} catch (error) {
		console.log('登录腾讯IM-error:', error);
		return Promise.reject({succ: false, isChatSDKReady, msg: error});
	}
	})();
	return loginPromise.finally(() => {
		loginPromise = null;
	});
};

// 登出
const logout = () => {
	if (!chatClient || !isLoggedIn) {
		return Promise.resolve();
	}
	return chatClient.logout().then((res)=>{
		isLoggedIn = false;
		currentUserID = null;
		currentToken = null;
		console.log('Logout successful',res.data);
	}).catch(err=>{
		console.log(err);
	})
};
// 销毁
const destroy = () => {
	try {
		isLoggedIn = false;
		currentUserID = null;
		currentToken = null;
		if (chatClient) {
			chatClient.destroy();
		}
		chatClient = null;
		console.log('destroy successful');
	} catch (error) {
		console.log(error);
	}
};

const userInfos = {}
const getUserInfos = async (userIDs) => {
	if (!chatClient) {
		console.log('ChatClient not initialized');
		return userIDs;
	}
	// console.log(userInfos);
	// var _lessUsersIDs = userIDs.filter(userID => !userInfos[userID]);
	var _lessUsersIDs = userIDs;
	if(_lessUsersIDs.length>0){
		console.log('getUserInfos_lessUsersIDs', _lessUsersIDs);
		try {
			await (async function awaitReady(){
				return new Promise( async(resolve)=>{
					if(isChatSDKReady) {
						var res = await chatClient.getUserProfile({userIDList:_lessUsersIDs});
						console.log('批量获取用户信息',res);
						// debugger
						if (res && res.data) {
							res.data.find(e=>{
								if(!userInfos[e.userID]) userInfos[e.userID] = {};
								Object.assign(userInfos[e.userID], e);
								let hasContacts = allFriends.find(a=>a.userID == e.userID);
								if(hasContacts){
									Object.assign(userInfos[e.userID], hasContacts);
									userInfos[e.userID].remark = hasContacts.remark;
									userInfos[e.userID].isContact = true;
								}
								resolve();
							})
						}
						
					} else {
						setTimeout(()=>{
							return awaitReady().then(()=>{
								resolve();
							})
						},50)
					}
				})
			})()
		} catch (error) {
			console.log('批量获取用户信息失败:', error);
		}
	}
	return userIDs.map(userID => {
		const userInfo = userInfos[userID] || {};
		return userInfo;
	});
}

// 导出实例和公共方法
export default {
	TencentCloudChat,
	ChatClient,
	login,
	logout,
	destroy,
	registerEvent,
	registerEvents,
	isLoggedIn: () => isLoggedIn,
	getUserInfos,
	AllFriends,
	AllBlacklist,
	AllFriendApplicationList,
};